import type { Mesh, Line, Group } from 'three';

export class AnnotationItem {
  constructor(
    public id: number | string, //UUIDv4 if string
    public index: number,
    public name: string,
    public geometry: Mesh | Line | Group,
    public type: string,
    public subType: string,
  ) {}

  get isVisible(): boolean {
    return this.geometry.visible;
  }
}
